import React, { useRef, useState, useEffect } from "react";
import { globalSearch } from "src/atom/GlobalSearch";
import { loadingState } from "src/atom/LoadingState";
import { alertMessageState } from "src/atom/LoadingState";
import { useRecoilState } from "recoil";
import { OverlayTrigger, Tooltip, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import {
  addLabels,
  createlabel,
  fetchStatus,
  getCategory,
  getSubCategory,
  getTicketLabels,
  search,
} from "src/services/Tickets/StudentTicketService";
import Paginator from "src/components/Paginator";
import {
  CCol,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
  CButton,
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
} from "@coreui/react";

export default function HelpDesk() {
  const collegeObj = {
    id: "",
    label: { id: null },
    ticketIds: [],
  };
  const searchObj = {
    id: "",
    ticketNumber: "",
    regNumber: "",
    userName: "",
    startDate: "",
    endDate: "",
    status: "",
    ticketCategoryId: "",
    subTicketCategoryId: "",
    advertisementNumber: "",
    postId: "",
    raisedRole: "",
  };
  const [visible, setVisible] = useState(false);
  const [, setIsSubmitted] = useState(false);
  const [, enableLoader] = useRecoilState(loadingState);
  const [GSearch, setGlobalSearch] = useRecoilState(globalSearch);
  const [formData, setFormData] = useState(collegeObj);
  const [searchData, setSearchData] = useState(searchObj);
  const [, setLoading] = useState(false);
  const [label, setLabel] = useState([]);
  const [status, setStatus] = useState([]);
  const [allcategory, setCategory] = useState([]);
  const [subCategory, setSubCategory] = useState([]);
  const [nextViewHistory, setNextViewHistory] = useState(null);
  const [, setDropdownOpen] = useState(false);
  const [, setAlertMessage] = useRecoilState(alertMessageState);
  const [ticketId, setTicketId] = useState([]);

  const [validationErrors, setValidationErrors] = useState({
    name: "",
  });

  const getAllStaus = async () => {
    var response = await fetchStatus();
    if (response.success) {
      setStatus(response.body);
    } else {
      setAlertMessage(`${response.message}`);
    }
  };

  const [pagination, setPagination] = useState({
    currentPage: 1,
    perPage: 10,
    totalItems: 0,
    totalPages: 0,
    next: "",
    prev: "",
    size: 10,
    search: "",
  });

  const nextPage = (event) => {
    setPagination((prevValue) => ({
      ...prevValue,
      currentPage: event,
    }));
  };

  const [tickets, setTickets] = useState([]);

  const validateForm = () => {
    let errors = {};
    let isValid = true;
    if (!formData.name) {
      errors.name = "Please provide Label Name";
      isValid = false;
    }
    setValidationErrors(errors);
    return isValid;
  };
  const navigate = useNavigate();
  const handleViewButtonClick = (id) => {
    navigate("/view-ticket-history", { state: { id, nextViewHistory } });
  };
  const handelTemplateClick = () => {
    navigate("/ticket-reply");
  };

  const handelLabelClick = () => {
    navigate("/manage-labels");
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSearchData((prevSearchData) => ({
      ...prevSearchData,
      [name]: value,
    }));
  };

  const handleSubmitChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitted(true);
    const isValid = validateForm();
    if (isValid) {
      setValidationErrors({});
      setLoading(true);
      const response = await createlabel(formData);
      if (response.success) {
        setFormData({});
        setVisible(false);
      } else {
        setAlertMessage(`${response.message}`);
      }
      setLoading(false);
    }
  };

  useEffect(() => {
    if (GSearch) getSearch();
    getAllLabels();
    getAllStaus();
    fetchCategory();
  }, [pagination.currentPage, pagination.size]);

  const getAllLabels = async () => {
    enableLoader(true);
    var getLabelss = async () => {
      enableLoader(false);
      var response = await getTicketLabels();
      if (response.success) {
        setLabel(response.body.labels);
        enableLoader(false);
      } else {
        enableLoader(false);
        setAlertMessage(`${response.message}`);
      }
    };
    getLabelss();
  };

  const dropdownRef = useRef(null);

  const closeDropdown = () => {
    setDropdownOpen(false);
  };

  const handleSearch = async (searchData) => {
    setGlobalSearch((prevGlobalSearch) => ({
      ...prevGlobalSearch,
      ticketNumber: searchData.ticketNumber,
      startDate: searchData.startDate,
      endDate: searchData.endDate,
      status: searchData.status,
      ticketCategoryId: searchData.ticketCategoryId,
      subTicketCategoryId: searchData.subTicketCategoryId,
      advertisementNumber: searchData.advertisementNumber,
      regNumber: searchData.regNumber,
      raisedRole: searchData.raisedRole,
    }));
  };

  useEffect(() => {
    getSearch();
  }, [GSearch, pagination.currentPage, pagination.size]);

  const getSearch = async () => {
    const response = await search({
      advertisementNumber: GSearch.advertisementNumber,
      ticketNumber: GSearch.ticketNumber,
      regNumber: GSearch.regNumber,
      startDate: GSearch.startDate,
      endDate: GSearch.endDate,
      status: GSearch.status,
      ticketCategoryId: GSearch.ticketCategoryId,
      subTicketCategoryId: GSearch.subTicketCategoryId,
      pageNumber: pagination.currentPage,
      search: pagination.search,
      pageSize: pagination.size,
      raisedRole: GSearch.raisedRole,
    });
    if (response.success) {
      setTickets(response.body);
      setNextViewHistory(response.body.tickets.map((ticket) => ticket.id));
      setPagination((prevValue) => ({
        ...prevValue,
        totalItems: response.body.totalElements,
        totalPages: Math.ceil(response.body.totalElements / pagination.size),
      }));
    } else {
      setAlertMessage(`${response.message}`);
    }
  };

  const handleStatusChange = (selectedStatus) => {
    setSearchData((prevSearchData) => ({
      ...prevSearchData,
      status: selectedStatus,
    }));
  };

  const fetchCategory = async () => {
    enableLoader(true);
    const fetchAllCategory = async () => {
      enableLoader(false);
      var response = await getCategory();
      if (response.success) {
        setCategory(response.body);
        enableLoader(false);
      } else {
        enableLoader(false);
        setAlertMessage(`${response.message}`);
      }
    };
    fetchAllCategory();
  };

  const handleTicketSubCategoryChange = (category) => {
    setSearchData((prevSearchData) => ({
      ...prevSearchData,
      subTicketCategoryId: category,
    }));
  };

  const fetchSubCategory = async (categoryId) => {
    enableLoader(true);
    const fetchAllSubCategory = async (categoryId) => {
      enableLoader(false);
      var response = await getSubCategory(categoryId);
      if (response.success) {
        setSubCategory(response.body);
        enableLoader(false);
      } else {
        enableLoader(false);
        setAlertMessage(`${response.message}`);
      }
    };
    fetchAllSubCategory(categoryId);
  };

  const handleTicketCategoryChange = (category) => {
    if (category) fetchSubCategory(category);
    setSearchData((prevSearchData) => ({
      ...prevSearchData,
      ticketCategoryId: category,
    }));
  };

  const handleGlobalClick = (event) => {
    if (dropdownRef.current && dropdownRef.current.contains(event.target)) {
      return;
    }
    closeDropdown();
  };

  document.addEventListener("mousedown", handleGlobalClick);

  const handleClearFilters = async (e) => {
    enableLoader(true);
    setGlobalSearch({
      advertisementNumber: "",
      ticketNumber: "",
      regNumber: "",
      startDate: "",
      endDate: "",
      status: "",
      ticketCategoryId: "",
      subTicketCategoryId: "",
      raisedRole: "false",
    });
    setSearchData(searchObj);
    setPagination({
      currentPage: 1,
      size: 10,
      totalItems: 0,
      totalPages: 0,
      search: "",
    });
    await getSearch();
    enableLoader(false);
  };

  const [isModalVisible, setIsModalVisible] = useState(false);

  const toggleModal = (id) => {
    setIsModalVisible(!isModalVisible);
    setTicketId(id);
  };

  const handleLabelChange = async (labelId) => {
    const response = await addLabels(labelId, [ticketId]);
    if (response.success) {
      setFormData({});
      setIsModalVisible(false);
      getSearch();
    } else {
      setAlertMessage(response.message);
    }
  };

  return (
    <>
      <div style={{ overflow: "hidden" }}>
        <div className="card">
          <div
            className="card-header text-white"
            style={{ backgroundColor: "#3C4B64" }}
          >
            <div className="d-flex align-items-center justify-content-between">
              <span className="mr-auto">All Tickets</span>
              <div className="d-flex justify-content-end">
                <CButton
                  style={{ marginRight: "10px" }}
                  onClick={() => {
                    handelTemplateClick();
                  }}
                >
                  Manage Templates
                </CButton>
                <CButton
                  style={{ marginRight: "10px" }}
                  onClick={() => {
                    handelLabelClick();
                  }}
                >
                  Manage Labels
                </CButton>
              </div>
            </div>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-md-2">
                <label htmlFor="ticketNumber" className="me-2 ms-2 fw-bold">
                  Ticket Number
                </label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Ticket Number...."
                  id="ticketNumber"
                  name="ticketNumber"
                  value={searchData.ticketNumber}
                  onChange={(e) => {
                    const value = e.target.value
                      .slice(0, 14)
                      .replace(/\D/g, "");
                    setSearchData({ ...searchData, ticketNumber: value });
                  }}
                  maxLength={14}
                />
              </div>

              <div className="col-md-2">
                <label htmlFor="regNumber" className="me-2 ms-2 fw-bold">
                  CET Reg Number
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Registeration Number ...."
                  id="regNumber"
                  name="regNumber"
                  value={searchData.regNumber}
                  onChange={handleInputChange}
                />
              </div>

              <div className="col-md-2">
                <label htmlFor="startDate" className="me-2 ms-2 fw-bold">
                  Start Date:
                </label>
                <input
                  type="date"
                  id="startDate"
                  className="form-control"
                  name="startDate"
                  value={searchData.startDate}
                  onChange={handleInputChange}
                  onFocus={(e) => e.target.showPicker && e.target.showPicker()}
                />
              </div>

              <div className="col-md-2">
                <label htmlFor="endDate" className="me-2 ms-2 fw-bold">
                  End Date:
                </label>
                <input
                  type="date"
                  id="endDate"
                  className="form-control"
                  name="endDate"
                  value={searchData.endDate}
                  onChange={handleInputChange}
                  onFocus={(e) => e.target.showPicker && e.target.showPicker()}
                />
              </div>
              <div className="col-md-2">
                <label htmlFor="status" className="me-2 ms-2 fw-bold">
                  Status
                </label>
                <select
                  name="status"
                  value={searchData?.status}
                  onChange={(e) => handleStatusChange(e.target.value)}
                  className="form-control"
                  id="status"
                  style={{
                    backgroundColor: "white",
                    color: "black",
                    textAlign: "left",
                  }}
                >
                  <option>Select Status</option>
                  {status.map((option) => (
                    <option key={option.value} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-2">
                <label htmlFor="ticketCategoryId" className="me-2 ms-2 fw-bold">
                  Category
                </label>
                <select
                  name="ticketCategoryId"
                  value={searchData.ticketCategoryId}
                  onChange={(e) => {
                    handleTicketCategoryChange(e.target.value);
                  }}
                  className={`form-control `}
                  id="ticketCategoryId"
                  style={{
                    backgroundColor: "white",
                    color: "black",
                    textAlign: "left",
                  }}
                >
                  <option value="">Select Category</option>
                  {allcategory?.map((result) => (
                    <option key={result.id} value={result.id}>
                      {result.category}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-2">
                <label
                  htmlFor="subTicketCategoryId"
                  className="me-2 ms-2 fw-bold mt-3"
                >
                  Sub-Category
                </label>
                <select
                  name="subTicketCategoryId"
                  value={searchData.subTicketCategoryId}
                  onChange={(e) => {
                    handleTicketSubCategoryChange(e.target.value);
                  }}
                  className={`form-control `}
                  id="subTicketCategoryId"
                  style={{
                    backgroundColor: "white",
                    color: "black",
                    textAlign: "left",
                  }}
                >
                  <option value="">Select Sub Category.</option>
                  {subCategory?.map((categoryy) => (
                    <option key={categoryy.id} value={categoryy.id}>
                      {categoryy.category}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-2 col-sm-4 mt-sm-4">
                <button
                  className="btn btn-info w-100 mt-3"
                  onClick={() => handleSearch(searchData)}
                >
                  Search
                </button>
              </div>
              <div className="col-md-2 col-sm-4 mt-sm-4">
                <button
                  className="btn btn-info w-100 mt-3"
                  onClick={() => handleClearFilters()}
                >
                  Clear Filters
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <CCol xs={12}>
            <div className="table-responsive">
              <CTable striped>
                <CTableHead>
                  <CTableRow>
                    <CTableHeaderCell scope="col">S.No</CTableHeaderCell>
                    <CTableHeaderCell scope="col">Roll Number</CTableHeaderCell>
                    <CTableHeaderCell scope="col">
                      Ticket Category
                    </CTableHeaderCell>
                    <CTableHeaderCell scope="col">
                      Ticket Sub-Category
                    </CTableHeaderCell>
                    <CTableHeaderCell scope="col">
                      Candidate Name
                    </CTableHeaderCell>
                    <CTableHeaderCell scope="col">Updated On</CTableHeaderCell>
                    <CTableHeaderCell scope="col">Label</CTableHeaderCell>
                    <CTableHeaderCell scope="col">Status</CTableHeaderCell>
                    <CTableHeaderCell scope="col">Action</CTableHeaderCell>
                  </CTableRow>
                </CTableHead>
                <CTableBody>
                  {Array.isArray(tickets.tickets) &&
                  tickets.tickets.length > 0 ? (
                    tickets.tickets.map((ticket, index) => {
                      return (
                        <OverlayTrigger
                          key={`tooltip-${index}`}
                          placement="top"
                          overlay={
                            <Tooltip id={`tooltip-${index}`}>
                              {ticket.newData ? (
                                <>
                                  {ticket.oldData} {ticket.newData}
                                </>
                              ) : (
                                <>
                                  {ticket.query !== "" ? ticket.query : "-NA-"}
                                </>
                              )}
                            </Tooltip>
                          }
                        >
                          <CTableRow key={index}>
                            <CTableHeaderCell scope="row">
                              {index + 1}
                            </CTableHeaderCell>
                            <CTableDataCell>
                              {ticket?.raisedBy?.userId}
                            </CTableDataCell>
                            <CTableDataCell>
                              {ticket?.ticketCategory}
                            </CTableDataCell>
                            <CTableDataCell>
                              {ticket?.subCategory}
                            </CTableDataCell>
                            <CTableDataCell>
                              {ticket?.raisedBy?.name}
                            </CTableDataCell>
                            <CTableDataCell>
                              {ticket.lastStatusUpdate}
                            </CTableDataCell>
                            <CTableDataCell>
                              {ticket?.label ? ticket.label : "N/A"}
                            </CTableDataCell>
                            <CTableDataCell>{ticket.status}</CTableDataCell>
                            <CTableDataCell>
                              <button
                                type="button"
                                className="btn btn-sm btn-success"
                                onClick={() => {
                                  handleViewButtonClick(ticket.id);
                                }}
                              >
                                View History
                              </button>
                              <button
                                type="button"
                                className="btn btn-sm btn-info ms-2"
                                onClick={() => {
                                  toggleModal(ticket.id);
                                }}
                              >
                                Assign Label
                              </button>
                            </CTableDataCell>
                          </CTableRow>
                        </OverlayTrigger>
                      );
                    })
                  ) : (
                    <CTableRow>
                      <CTableDataCell colSpan={11}>
                        No Ticket found
                      </CTableDataCell>
                    </CTableRow>
                  )}
                </CTableBody>
              </CTable>
            </div>
            <div className="row">
              <div className="col-12 d-flex justify-content-center">
                <Paginator
                  pagination={pagination}
                  range={3}
                  nextPage={nextPage}
                  setPagination={setPagination}
                />
              </div>
            </div>
          </CCol>
        </div>
      </div>

      <CModal
        scrollable
        visible={visible}
        onClose={() => setVisible(false)}
        size="l"
      >
        <CModalHeader>
          <CModalTitle> Labels </CModalTitle>
        </CModalHeader>
        <CModalBody>
          <div className="container mt-4">
            <form onSubmit={handleSubmit}>
              <div className="row mb-2">
                <div className="col-md-12">
                  <div className="form-group">
                    <label htmlFor="name">Label Name</label>
                    <input
                      type="text"
                      className={`form-control ${
                        validationErrors.name ? "is-invalid" : ""
                      }`}
                      id="name"
                      placeholder="Enter Label Name"
                      name="name"
                      value={formData?.name}
                      onChange={handleSubmitChange}
                    />
                    {validationErrors.name && (
                      <div className="invalid-feedback">
                        {validationErrors.name}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="mt-5 text-center">
                <button type="submit" className="btn btn-success text-white">
                  Submit
                </button>
              </div>
            </form>
          </div>
        </CModalBody>
      </CModal>

      <Modal show={isModalVisible} onHide={toggleModal}>
        <Modal.Header closeButton>
          <Modal.Title>Assign Label</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row align-items-center">
            <div className="col-auto">
              <label htmlFor="label">Select Label :</label>
            </div>
            <div className="col">
              <select
                name="state"
                value={formData.name ? formData.name : ""}
                onChange={(e) => handleLabelChange(e.target.value)}
                className={`form-control ${
                  validationErrors.state ? "is-invalid" : ""
                }`}
                id="state"
              >
                <option value=""> Assign Label</option>
                {label?.map((state) => (
                  <option key={state.id} value={state.id}>
                    {state.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
